import * as queryKeys from '../constants/keys';

/** Same tuple as invalidations/useQuery reads — optimistic snapshot + rollback must match. */
export const pmSprintProductsQueryKey = (detail?: { sprintId: string; productId: string }) =>
  detail ? ([queryKeys.PM_SPRINT_PRODUCTS, detail] as const) : ([queryKeys.PM_SPRINT_PRODUCTS] as const);
